import cn from 'classnames'
import React, { useContext } from 'react'
import Image from 'next/image'

import { SiteDataContext } from '../../components/page-wrapper'
import { getMicroCopy } from '../../utils/microcopy'
import { NavLink } from '../helpers'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

// Logo variants mapping
const LOGO_VARIANTS = {
  black: '/images/deliverect_logo_black.svg',
  white: '/images/deliverect_logo_white.svg',
  green: '/images/deliverect_logo_green.svg'
}

// SVG logo path for the icon version
const LOGO_SVG_PATH =
  'M20.8816 3.7173V12.6592C20.8816 17.0777 17.3001 20.6592 12.8816 20.6592C8.46306 20.6592 4.88159 17.0777 4.88159 12.6592C4.88159 8.24066 8.46306 4.65919 12.8816 4.65919H13.7707V9.99279H12.8816C11.409 9.99279 10.2152 11.1866 10.2152 12.6592C10.2152 14.1318 11.409 15.3256 12.8816 15.3256C14.3542 15.3256 15.548 14.1318 15.548 12.6592V0.960694C14.6898 0.765652 13.7983 0.660004 12.8816 0.660004C6.2542 0.660004 0.881592 6.03262 0.881592 12.66C0.881592 19.2874 6.2542 24.66 12.8816 24.66C19.509 24.66 24.8816 19.2874 24.8816 12.66C24.8816 9.10698 23.3359 5.91559 20.8816 3.71811V3.7173Z'

const Logo = ({
  withText = false,
  inverted = false,
  size = 30,
  width = 168,
  anchorProps,
  link = '',
  classes = '',
  variant = 'green'
}) => {
  const microCopyData = useMicroCopyData()
  const { lang } = useContext(SiteDataContext)

  // Get logo path based on variant
  const logoPath = LOGO_VARIANTS[variant] || LOGO_VARIANTS.green

  // Build CSS classes
  const logoClasses = cn('c-logo', classes, {
    'c-logo--inverted': inverted,
    'c-logo--with-text': withText
  })

  // Get accessibility label
  const label = getMicroCopy({
    key: 'logo',
    fallback: 'Deliverect logo',
    data: microCopyData[lang]
  })

  // Render logo content
  const logoContent = withText ? (
    <Image className={classes} height={size} width={width} src={logoPath} priority alt="Logo" />
  ) : (
    <svg
      className={logoClasses}
      height={size}
      width={width}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={LOGO_SVG_PATH} fill="currentColor" />
    </svg>
  )

  // Render with or without link wrapper
  if (link) {
    return (
      <NavLink to={link} {...anchorProps}>
        {logoContent}
        <span className="c-logo__label">{label}</span>
      </NavLink>
    )
  }

  return logoContent
}

export default Logo
